export type ESimFilters = {
  searchText: string;
};

export type ValidESimFiltersKeys = keyof ESimFilters;

export const ESIM_INITIAL_FILTERS: ESimFilters = {
  searchText: '',
};
